import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

const StackedColumnChartVisa = ({ dataColors, datamonth }) => {
  const [series, setSeries] = useState([]);
  const stackedColumnChartColors = getChartColorsArray(dataColors);

  useEffect(() => {
    console.log("datamonth:", datamonth);
    if (datamonth) {
      const groupedData = groupMonthlyData(datamonth);
      setSeries(groupedData);
    }
  }, [datamonth]);

  const groupMonthlyData = (data) => {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const statusTypes = [
      { key: "ACCEPTED", label: "Accepted" },
      { key: "PENDING", label: "Pending" },
      { key: "REFUSED", label: "Refused" },
    ];

    const grouped = statusTypes.map((status) => ({
      name: status.label,
      data: Array(12).fill(0),
    }));

    Object.entries(data).forEach(([monthYear, visas]) => {
      const [year, month] = monthYear.split("-");
      const monthIndex = parseInt(month) - 1; // Months are 0-indexed

      visas.forEach((visa) => {
        const statusIndex = statusTypes.findIndex((status) => status.key === visa.status);
        if (statusIndex !== -1) {
          grouped[statusIndex].data[monthIndex] += 1;
        }
      });
    });

    return grouped;
  };

  const options = {
    chart: {
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "15%",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    colors: stackedColumnChartColors,
    legend: { position: "bottom" },
    fill: { opacity: 1 },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height="359"
      className="apex-charts"
    />
  );
};

StackedColumnChartVisa.propTypes = {
  dataColors: PropTypes.string.isRequired,
  datamonth: PropTypes.object.isRequired,
};

export default StackedColumnChartVisa;